import React from 'react';
import {getServerTexts} from '../texts';
import {PersonalizationDialog} from './PersonalizationDialog';

export const personalizationDialogRef: React.RefObject<any> = React.createRef();

export async function renderPersonalizationDialog(root) {
    await getServerTexts();

    root.render(<PersonalizationDialog ref={personalizationDialogRef} />);

    return personalizationDialogRef;
}
